import { HomeSorting } from '@/types/character'
import { Gender } from '@/types/types'
import { VALID_HOME_SORTINGS } from '@/constant/prefetch-home-sorting'
import { i18nKey } from '@/lib/i18n-key'

// 桌面端可见排序列表。派生自零依赖单一事实源 VALID_HOME_SORTINGS（constant/prefetch-home-sorting.ts），
// 与 boot 的 normalizeHomeSorting 同读一份白名单，杜绝「页面合法集 / boot 归一化白名单」双写漂移。
// 移动端 MobileSortingList 保持独立定义（设计上允许与桌面不同）。
export const SortingList = VALID_HOME_SORTINGS as readonly HomeSorting[]

export const MobileSortingList: HomeSorting[] = [
  i18nKey('For You'),
  i18nKey('Weekly Picks'),
  i18nKey('World'),
  i18nKey('New Releases'),
  i18nKey('All-Time Faves'),
  i18nKey('Following'),
] as const

export const SexList = [
  i18nKey('All'),
  i18nKey('Female'),
  i18nKey('Male'),
  i18nKey('Non-binary'),
] as const
export const SearchSexList = ['All', 'Female', 'Male', 'Non-binary'] as const
export const GenderList: Array<Gender> = ['male', 'female', 'other'] as const
export const SortingTypeList: Array<HomeSorting> = [
  'Recommend',
  'Popular',
  'Latest',
  'Trending',
] as const

// 搜索结果页 Sort by 选项（PRD：搜索结果页优化）。值即前后端契约（与后端 SearchSorting* 常量一致）。
export const SearchSortingList = [
  'Recommended',
  'Most Interacted',
  'Most Liked',
  'Most Favorited',
  'Latest',
] as const
export type SearchSorting = (typeof SearchSortingList)[number]

// UI 文案 → 后端 sorting 枚举值映射
export const SearchSortingValueMap: Record<SearchSorting, string> = {
  Recommended: 'Recommended',
  'Most Interacted': 'MostInteracted',
  'Most Liked': 'MostLiked',
  'Most Favorited': 'MostFavorited',
  Latest: 'Latest',
} as const

// Content Rating 选项（limitless 开关打开时展示）。值即前后端契约。
export const ContentRatingList = ['All', 'SFW', 'NSFW'] as const
export type ContentRating = (typeof ContentRatingList)[number]

//点赞收藏下四个选项卡
export const ProfileTabs = [
  'Characters',
  'Multi-character',
  'RoleCard',
  'Memories',
  'Favorites',
  'Liked',
] as const
export const CharacterStatusList = [
  'All',
  'Passed',
  'Pending',
  'Failed',
] as const

export const UserGender: Record<Gender, string> = {
  male: 'Male',
  female: 'Female',
  other: 'Non-binary',
} as const

export const AgeRange: Record<string, string> = {
  '1': '18-24',
  '2': '25-34',
  '3': '35-44',
  '4': '45+',
}

export const FreeCountry = [
  'PH',
  'MY',
  'ID',
  'NP',
  'VE',
  'ZA',
  'IN',
  'PK',
  'TT',
  'TM',
  'BD',
  'GT',
  'KE',
  'NG',
  'DZ',
  'MA',
  'TN',
  'JM',
  'JO',
  'ET',
  'PY',
  'PS',
  'IR',
  'EQ',
  'IQ',
  'TR',
  'GE',
  'HR',
  'T1',
  'VN',
  'LB',
  'UY',
  'DO',
  'CO',
  'BO',
  'EG',
  'IQ',
  'NI',
  'GE',
  'BA',
  'AZ',
  'MM',
  'UZ',
  'MN',
  'KH',
  'BT',
  'ZW',
  'GH',
  'GY',
  'LY',
  'BZ',
  'MU',
  'CU',
  'SN',
  'MD',
  'FJ',
  'UG',
  'MG',
  'CM',
  'BW',
  'NA',
  'BB',
  'BN',
  'ZM',
  'BS',
  'RE',
  'SR',
  'XK',
  'CI',
  'AF',
  'MK',
  'CG',
  'TZ',
  'RW',
  'PG',
  'HT',
  'KG',
  'GP',
  'TG',
  'AM',
  'CW',
  'MW',
  'GQ',
  'ME',
  'LC',
  'GA',
  'GL',
  'SO',
  'TO',
  'MZ',
  'DM',
  'AO',
  'SX',
  'VI',
  'GM',
  'ML',
  'TJ',
  'GD',
  'PF',
  'AW',
  'VC',
  'SY',
  'LA',
  'CV',
  'BJ',
  'AX',
  'SZ',
  'BF',
  'LS',
  'FM',
  'TC',
  'AG',
  'SC',
  'MP',
  'SL',
  'MQ',
  'LR',
  'DJ',
  'CK',
  'MR',
  'GN',
  'VG',
  'BI',
  'TL',
  'VU',
  'WS',
  'FO',
  'GG',
  'AS',
  'SD',
  'PW',
  'KM',
  'NE',
  'AI',
  'BQ',
  'TD',
  'SB',
  'LI',
  'SS',
  'ER',
  'YT',
  'KN',
  'GW',
  'MF',
  'FK',
  'RU',
]

// 需要显示红点提示的tag列表
export const NEW_START_TAG = 'NewStart'
